module.exports = __webpack_public_path__ + "static/media/logo.f1644ad2.svg";